import styles from './AuditionCard.module.css';
import AuditionCardHeader from './AuditionCardHeader';
import AuditionCardContent from './AuditionCardContent';
import AuditionCardFooter from './AuditionCardFooter';

function AuditionCard({
  category,
  location,
  dDay,
  title,
  company,
  castingDirectorName,
  role,
  status,
  isNew,
  isClosing = false,
  roles,
  isSaved,
  savedColor = null,
  isRead = false,
  isList = false,
  showRoleTags = true,
  onSaveToggle,
  onClick,
  className = '',
}) {
  // 시각적 상태: list-read(파인 디자인), list-unread(나온 디자인), box(기본)
  const viewMode = isList 
    ? (isRead ? 'list-read' : 'list-unread') 
    : 'box';

  const isClosed = status === 'closed';
  const isDark = className === styles.auditionCardDark;
  const stateClass = isDark
    ? ''
    : (isClosed ? styles.auditionCardClosed : (isRead ? styles.auditionCardRead : styles.auditionCardUnread));

  const cardClasses = [
    styles.auditionCard,
    isList ? styles.auditionCardList : '',
    stateClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <article
      className={cardClasses}
      onClick={onClick}
      data-read={isRead}
      data-variant={isList ? 'list' : 'box'}
      data-view-mode={viewMode}
    >
      <AuditionCardHeader
        category={category}
        location={location}
        dDay={dDay}
        status={status}
        isNew={isNew}
        isClosing={isClosing}
        isSaved={isSaved}
        savedColor={savedColor}
        onSaveToggle={onSaveToggle}
      />
      <AuditionCardContent title={title} company={company} castingDirectorName={castingDirectorName} />
      {showRoleTags && <AuditionCardFooter role={role} roles={roles} />}
    </article>
  );
}

export default AuditionCard;
